import { Button } from '@/components/ui/button';
import LayoutOutside from '@/layout/LayoutOutside';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@/assets/check.svg';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/Auth';

export function InvitationAcceptConfirm() {
  const { t } = useTranslation('invitationAcceptInvite');
  const navigate = useNavigate();
  const { fetchUserData } = useAuth();

  function handleClick() {
    fetchUserData();
    navigate('/dashboard');
  }

  return (
    <LayoutOutside
      classNameMainContainer="flex items-center justify-center h-[calc(100vh-64px)]"
      hideButton
    >
      <section className="max-w-xs w-full flex flex-col items-center space-y-8">
        <img
          src={CheckIcon}
          alt={t('confirm_icon_alt')}
          className="w-14 h-14 rounded-full"
        />

        <div className="space-y-3 text-center">
          <h1 className="text-3xl font-semibold">{t('invite_accepted')}</h1>
          <p className="text-muted-foreground">
            {t('invite_accepted_description')}
          </p>
        </div>

        <Button onClick={handleClick}>{t('access_platform')}</Button>
      </section>
    </LayoutOutside>
  );
}
